/*
 *   File : review-details.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - Details review page
 *   Integrations : react-toastify
 *   Version : 1.0.0
 *   Date : 23-09-2022  
*/

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


// *********** Components ***************//  
import { PrimaryButton, TextButton } from "../../../Component/Buttons";
import PersonalDetails from "./edit-personal-details";
import { Icon } from "../../../Component/Icon";
import { _amountInWords, _getUserData } from "../../../Helper";


// *********** Styles ***************//  
import styles from "../../../Style/Component/login.module.scss";


// *********** Assets ***************// 
import Loader from "../../../Assets/Images/loader.gif";
import { DocumentPreviewModal } from "../../../Component/Modal";
import { Modal } from "bootstrap";


function ReviewDetails(props) {

    const PROGRESS_DATA = useSelector((store) => store.Reducer.SIGNUP_PROGRESS_DATA);
    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const [userData, setUserData] = useState(USER_DATA || {});
    const [dataLoading, setDataLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(true);
    const [previewFile, setPreviewFile] = useState(null);
    const [showPreview, setShowPreview] = useState(false);

    useEffect(() => {
        setUserData(USER_DATA);
        if (USER_DATA) {
            let check_all_data_exist = _validatePersonalData(USER_DATA.personal_data);
            if (check_all_data_exist === false) {
                setShowEdit(true);
            } else {
                setShowEdit(false);
            }
            setDataLoading(false);
        }
    }, [USER_DATA]);

    useEffect(() => {
        if (showPreview) {
            let preview_modal = new Modal(document.querySelector("#document-preview"));
            preview_modal.show();
        }
    }, [showPreview]);


    const _validatePersonalData = (data) => {

        const is_valid = (value) => value == null || value == undefined && value == "" || value == 0 ? false : true;

        if (props.kycUser) {
            const is_all_valid = is_valid(data?.name) &&
                is_valid(data?.dob) &&
                is_valid(data?.gender) &&
                is_valid(data?.country) &&
                is_valid(data?.annual_income) &&
                is_valid(data?.occupation) &&
                is_valid(data?.marital_status) &&
                is_valid(data?.income_source);
            return is_all_valid;
        } else {
            const is_all_valid = is_valid(data?.name) &&
                is_valid(data?.father_name) &&
                is_valid(data?.mother_name) &&
                is_valid(data?.dob) &&
                is_valid(data?.gender) &&
                is_valid(data?.country) &&
                is_valid(data?.annual_income) &&
                is_valid(data?.occupation) &&
                is_valid(data?.marital_status) &&
                is_valid(data?.income_source) &&
                is_valid(data?.photo_proof_url) &&
                is_valid(data?.identity_proof_url) &&
                is_valid(data?.signature_proof_url);
            return is_all_valid;
        }
    };

    // handle edit details  
    const _handleEditDetails = () => {
        setShowEdit(true);
    };

    // Back to previous step -Onboarding
    const _handleBackToPrevious = () => {
        props.handleBack(1); // 1 - Pan verification
    };


    // handle Verify pan
    const _handleUpdateCurrentStep = async () => {
        if (props.kycUser === false && PROGRESS_DATA.is_identity_verified === true) {
            props.handleUpdateCurrentStep(4);  // Aadhaar fetch already done
        } else {
            props.handleUpdateCurrentStep(3);
        }
    };

    // handle show review details page
    const _handleShowReviewDetails = () => {
        setShowEdit(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const _handleShowPreview = (file) => {
        setShowPreview(true);
        setPreviewFile(file);
    };

    return (
        <>
            {
                dataLoading ?
                    <div className="col-sm-10 col-xl-9 mx-auto px-lg-0">
                        <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                            <div className={`${styles.e_onboarding_wrapper_review_details} e-border-radius-24`}>
                                <div className="min-h-100vh text-center mt-5 pt-5" >
                                    <img src={Loader}
                                        className='object-fit-contain w-20 width-24px-res'
                                        draggable="false"
                                        alt="loader" />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <>
                        {
                            showEdit ?
                                <PersonalDetails isNRI={props.isNRI}
                                    kycUser={props.kycUser}
                                    countryData={props.countryData}
                                    handleSuccess={_handleShowReviewDetails}
                                    handleBack={_handleBackToPrevious} />
                                :
                                <div className="col-sm-10 col-xl-9 mx-auto px-lg-0">
                                    <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                                        <div className={`${styles.e_onboarding_wrapper_review_details} e-border-radius-24`}>

                                            <div className="row justify-content-between">
                                                <div className="col">
                                                    <div className="d-flex gap-4">
                                                        {/* <Icon icon="arrow-back-left"
                                                            className="cursor-pointer"
                                                            size={24}
                                                            onClick={_handleBackToPrevious} /> */}
                                                        <h6 className="e-text-chinese-black e-font-16-res e-font-20 e-alt-font-poppins e-font-weight-600 line-height-24px mb-sm-4">
                                                            Review your details
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Personal Information */}
                                            <div className="mb-4 user-review-card mt-2">
                                                <h6 className="e-font-14-res mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                                    Personal Information
                                                </h6>
                                                <div className={`row  row-gap-3`}>
                                                    <div className={`col-md-3 col-6`}>
                                                        <p className="title-text">Full name</p>
                                                        <p className="value-text">{userData?.personal_data?.name || "-"}</p>
                                                    </div>
                                                    <div className={`col-md-3 col-6`}>
                                                        <p className="title-text">Date of birth</p>
                                                        <p className="value-text">{userData?.personal_data?.dob || "-"}</p>
                                                    </div>
                                                    <div className={`col-md-3 col-6`}>
                                                        <p className="title-text">Gender</p>
                                                        <p className="value-text">{userData?.personal_data?.gender || "-"}</p>
                                                    </div>
                                                    <div className="col-md-3 col-6">
                                                        <p className="title-text">Marital status</p>
                                                        <p className="value-text">{userData?.personal_data?.marital_status || "-"}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            {/* Nationality, Tax & Source */}
                                            <div className="mb-4 user-review-card">
                                                <h6 className="e-font-14-res mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                                    Nationality, Tax & Source
                                                </h6>
                                                <div className={`row ${props.isNRI ? "justify-content-between" : ""}  row-gap-3`}>
                                                    {
                                                        props.isNRI && (
                                                            <>
                                                                <div className={`col-lg-auto col-md-3 col-6`}>
                                                                    <p className="title-text">Nationality</p>
                                                                    <p className="value-text">{userData?.personal_data?.country || "-"}</p>
                                                                </div>
                                                                <div className={`col-lg-auto col-md-3 col-6`}>
                                                                    <p className="title-text">Foreign tax residency?</p>
                                                                    <p className="value-text">{userData?.personal_data?.foreign_tax_residence ? "Yes" : "No"}</p>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                    <div className={props.isNRI ? "col-lg-auto col-md-3 col-6" : "col-md-3 col-6"}>
                                                        <p className="title-text">Occupation</p>
                                                        <p className="value-text">{userData?.personal_data?.occupation || "-"}</p>
                                                    </div>
                                                    <div className={props.isNRI ? "col-lg-auto col-md-3 col-6" : "col-md-3 col-6"}>
                                                        <p className="title-text">Source of income</p>
                                                        <p className="value-text">{userData?.personal_data?.income_source || "-"}</p>
                                                    </div>
                                                    <div className={props.isNRI ? "col-lg-auto col-md-3 col-6" : "col-md-3 col-6"}>
                                                        <p className="title-text">Annual income</p>
                                                        <p className="value-text">{_amountInWords(userData?.personal_data?.annual_income || 0)}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Parent details */}
                                            {
                                                props.kycUser == false &&
                                                <div className="mb-4 user-review-card">
                                                    <h6 className="e-font-14-res mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                                        Parents details
                                                    </h6>
                                                    <div className={`row  row-gap-3`}>
                                                        <div className="col-md-3 col-6">
                                                            <p className="title-text">Fathers name</p>
                                                            <p className="value-text">{userData?.personal_data?.father_name || "-"}</p>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <p className="title-text">Mothers name</p>
                                                            <p className="value-text">{userData?.personal_data?.mother_name || "-"}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {/* Address Details */}
                                            <div className="mb-4 user-review-card">
                                                <h6 className="e-font-14-res mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                                    Address Details
                                                </h6>
                                                <div className="row justify-content-between row-gap-3">
                                                    <div className="col-md-6 col-sm-10 ">
                                                        <p className="title-text">Address</p>
                                                        {
                                                            userData?.address?.permanent_address["address_line1"] ?
                                                                <p className="value-text">
                                                                    {userData?.address?.permanent_address?.address_line1}{", "}
                                                                    {userData?.address?.permanent_address?.address_line2}{", "}
                                                                    {userData?.address?.permanent_address?.city}{", "}
                                                                    {userData?.address?.permanent_address?.state_name}{", "}
                                                                    {userData?.address?.permanent_address?.country_name}{", "}
                                                                    {userData?.address?.permanent_address?.pincode}.
                                                                </p>
                                                                :
                                                                "-"
                                                        }

                                                    </div>
                                                    {
                                                        userData.address.is_same_corresponding_address === false &&
                                                        <div className="col-md-6 col-sm-10 ">
                                                            <p className="title-text">{props.isNRI ? "Overseas Address" : "Corresponding Address"}</p>
                                                            {
                                                                userData?.address?.corresponding_address["address_line1"] ?
                                                                    <p className="value-text">
                                                                        {userData?.address?.corresponding_address?.address_line1}{", "}
                                                                        {userData?.address?.corresponding_address?.address_line2}{", "}
                                                                        {userData?.address?.corresponding_address?.city}{", "}
                                                                        {userData?.address?.corresponding_address?.state_name}{", "}
                                                                        {userData?.address?.corresponding_address?.country_name}{", "}
                                                                        {userData?.address?.corresponding_address?.pincode}.
                                                                    </p>
                                                                    :
                                                                    "-"
                                                            }

                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            {/* Parent details */}
                                            {
                                                props.kycUser == false &&
                                                <div className="mb-4 user-review-card">
                                                    <h6 className="e-font-14-res mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-20px">
                                                        Uploaded documents
                                                    </h6>
                                                    <div className={`row  row-gap-3`}>
                                                        <div className="col-md-3 col-6">
                                                            <p className="title-text">Pan card</p>
                                                            <span className="e-font-14-res e-text-egyptian-blue text-decoration-underline e-alt-font-poppins e-font-16 e-font-weight-500 cursor-pointer"
                                                                onClick={() => _handleShowPreview(userData?.personal_data?.identity_proof_url)}>
                                                                View preview
                                                            </span>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <p className="title-text">Signature</p>
                                                            <span className="e-font-14-res e-text-egyptian-blue text-decoration-underline e-alt-font-poppins e-font-16 e-font-weight-500 cursor-pointer"
                                                                onClick={() => _handleShowPreview(userData?.personal_data?.signature_proof_url)}>
                                                                View preview
                                                            </span>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <p className="title-text">Image</p>
                                                            <span className="e-font-14-res e-text-egyptian-blue text-decoration-underline e-alt-font-poppins e-font-16 e-font-weight-500 cursor-pointer"
                                                                onClick={() => _handleShowPreview(userData?.personal_data?.photo_proof_url)}>
                                                                View preview
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <div className="row justify-content-end align-items-center">
                                                <div className="col-auto">
                                                    <TextButton name="Update details" type={2} onClick={_handleEditDetails} />
                                                </div>
                                                <div className="col-auto col-sm-6 col-md-4 col-lg-4 flex-fill-res ">
                                                    <PrimaryButton name='Continue'
                                                        // loading={loading}
                                                        // disabled={loading}
                                                        className={`w-100 padding-12px-tb padding-8px-tb-res padding-12px-lr-res e-font-16`}
                                                        onPress={() => _handleUpdateCurrentStep()} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </>
            }

            {
                showPreview &&
                <DocumentPreviewModal file={previewFile} onCloseModal={() => setShowPreview(false)} />
            }
        </>

    )
}

export default ReviewDetails;